import request from '@/shared/api/request';

export const saveDatabaseTags = (
  uuid: string,
  data: { tags: string[] },
): Promise<{ tags: string[] }> =>
  request({
    url: `/databases/${uuid}/tags/`,
    method: 'PUT',
    data,
  });
